import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useGlobalCalls } from './global-calls.hook'
import { setConfigData } from '../slices'

export const useGlobalData = () => {
  const loaded = useSelector((state) => state.global.isLoaded)
  const data = useSelector((state) => state.global.data)
  const dispatch = useDispatch()
  const { getGlobals } = useGlobalCalls()

  useEffect(() => {
    if (!loaded) {
      getGlobals().then(({ data }) => {
        dispatch(setConfigData(data))
      })
    }
  }, [loaded]) // eslint-disable-line

  return {
    loaded: loaded,
    data: data,
  }
}
